var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSrv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.231 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aa{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19 -170)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1245.874 -616.116)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1274.331 788.05)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1276.736,789.137h-1.126a.46.46,0,0,1,0-.92h1.126a.46.46,0,0,1,0,.92Z",
    transform: "translate(-1275.149 -788.217)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1275.458 788.052)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1277.56,789.874a.477.477,0,0,1-.46-.462.27.27,0,0,0-.269-.272.46.46,0,0,1,0-.92h0a1.192,1.192,0,0,1,1.185,1.2A.461.461,0,0,1,1277.56,789.874Z",
    transform: "translate(-1276.373 -788.219)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1276.185 788.785)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1277.623,801.611a.46.46,0,0,1-.46-.46V789.476a.46.46,0,0,1,.92,0v11.674A.46.46,0,0,1,1277.623,801.611Z",
    transform: "translate(-1277.163 -789.016)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1275.458 800.459)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1276.833,803.356a.46.46,0,0,1,0-.92.264.264,0,0,0,.19-.08.273.273,0,0,0,.079-.193.461.461,0,0,1,.458-.462h0a.461.461,0,0,1,.46.458,1.193,1.193,0,0,1-1.185,1.2Z",
    transform: "translate(-1276.373 -801.7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1265.601 801.196)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1275.981,803.42h-9.856a.46.46,0,1,1,0-.92h9.856a.46.46,0,1,1,0,.92Z",
    transform: "translate(-1265.664 -802.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1264.874 800.459)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1266.061,803.356h0a1.193,1.193,0,0,1-1.185-1.2.479.479,0,0,1,.462-.458.461.461,0,0,1,.458.462.273.273,0,0,0,.079.193.264.264,0,0,0,.19.08.46.46,0,0,1,0,.92Z",
    transform: "translate(-1264.874 -801.7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1264.874 788.785)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1265.334,801.611a.46.46,0,0,1-.46-.46V789.476a.46.46,0,1,1,.92,0v11.674A.46.46,0,0,1,1265.334,801.611Z",
    transform: "translate(-1264.874 -789.016)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1264.874 788.052)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1265.334,789.873a.461.461,0,0,1-.46-.459,1.193,1.193,0,0,1,1.185-1.195h0a.46.46,0,0,1,0,.92.272.272,0,0,0-.269.272.46.46,0,0,1-.459.461Z",
    transform: "translate(-1264.874 -788.219)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1265.601 788.05)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1267.1,789.137h-.971a.46.46,0,0,1,0-.92h.971a.46.46,0,0,1,0,.92Z",
    transform: "translate(-1265.664 -788.217)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1271.769 786.813)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1274.7,787.954h-1.872a.46.46,0,0,1-.46-.46v-.16a.46.46,0,0,1,.809-.3h1.523a.46.46,0,1,1,0,.92Z",
    transform: "translate(-1272.365 -786.873)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1271.079 786.116)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1272.766,787.735h0a.461.461,0,0,1-.457-.464.233.233,0,0,0-.233-.235.46.46,0,0,1,0-.92h0a1.153,1.153,0,0,1,1.146,1.162A.46.46,0,0,1,1272.766,787.735Z",
    transform: "translate(-1271.616 -786.116)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1269.98 786.116)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1271.981,787.036h-1.1a.46.46,0,1,1,0-.92h1.1a.46.46,0,1,1,0,.92Z",
    transform: "translate(-1270.422 -786.116)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1269.289 786.116)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1270.131,787.735a.46.46,0,0,1-.46-.458,1.155,1.155,0,0,1,1.15-1.161h0a.46.46,0,0,1,0,.92.235.235,0,0,0-.233.237.461.461,0,0,1-.458.462Z",
    transform: "translate(-1269.671 -786.116)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1267.419 786.815)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1269.97,787.954h-1.87a.46.46,0,0,1,0-.92h1.523a.46.46,0,0,1,.807.3v.158A.46.46,0,0,1,1269.97,787.954Z",
    transform: "translate(-1267.639 -786.875)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1266.729 786.976)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1267.349,788.67a.46.46,0,0,1-.46-.458,1.157,1.157,0,0,1,1.147-1.162h0a.46.46,0,0,1,0,.92.235.235,0,0,0-.234.237.461.461,0,0,1-.458.462Z",
    transform: "translate(-1266.889 -787.05)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1266.729 787.673)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1274.952,790.215h-7.6a.46.46,0,0,1-.46-.46v-1.486a.46.46,0,0,1,.921,0v1.026h6.682v-1.026a.46.46,0,1,1,.92,0v1.486A.46.46,0,0,1,1274.952,790.215Z",
    transform: "translate(-1266.889 -787.808)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1273.643 786.976)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1275.55,788.67h0a.461.461,0,0,1-.457-.464.234.234,0,0,0-.232-.236.46.46,0,0,1,0-.92h0a1.155,1.155,0,0,1,1.145,1.162A.46.46,0,0,1,1275.55,788.67Z",
    transform: "translate(-1274.401 -787.05)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1266.762 792.004)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.686)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1268.01,794.759a.456.456,0,0,1-.314-.123l-.624-.58a.46.46,0,0,1,.628-.674l.623.579a.461.461,0,0,1-.313.8Z",
    transform: "translate(-1266.926 -793.259)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.624)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1268.064,794.7a.461.461,0,0,1-.342-.769l1.147-1.266a.461.461,0,1,1,.683.619l-1.146,1.266A.465.465,0,0,1,1268.064,794.7Z",
    transform: "translate(-1267.603 -792.514)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1269.62 792.767)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1275.168,794.262h-4.676a.46.46,0,0,1,0-.92h4.676a.46.46,0,1,1,0,.92Z",
    transform: "translate(-1270.031 -793.342)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1269.62 798.433)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1275.168,800.418h-4.676a.46.46,0,1,1,0-.92h4.676a.46.46,0,1,1,0,.92Z",
    transform: "translate(-1270.031 -799.498)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1269.62 795.641)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1275.168,797.385h-4.676a.46.46,0,1,1,0-.92h4.676a.46.46,0,1,1,0,.92Z",
    transform: "translate(-1270.031 -796.465)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrv);
export default __webpack_public_path__ + "static/media/srv.83cb9cd9.svg";
export { ForwardRef as ReactComponent };